import { Star } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

/**
 * "Favourites only" filter toggle — mirrors the portfolio's Favourites button
 * (style + `aria-pressed` pattern) so every favourites filter in Segment
 * Analysis looks and behaves the same. Used by the Companies tab (#3306 #6)
 * and meant to be reused by the Customers tab.
 */
export function FavouritesFilterToggle({
  active,
  className,
  label = "Favourites",
  onToggle,
}: {
  active: boolean
  className?: string
  label?: string
  onToggle: () => void
}) {
  return (
    <Button
      aria-pressed={active}
      variant="outline"
      className={cn(
        "h-10 shadow-sm",
        active &&
          "border-warning/40 bg-warning/15 text-warning-foreground hover:bg-warning/15 hover:text-warning-foreground",
        className
      )}
      onClick={onToggle}
    >
      <Star className={cn("size-4", active && "fill-warning-ink text-warning-ink")} />
      {label}
    </Button>
  )
}
